import config from "./../config";
import {v4 as uuid} from "uuid";
import Cookies from "js-cookie";

export default {
    trackShareFormPageView() {
        const scriptElement = config.getCurrentScript();
        if (scriptElement) {
            const pubId = config.getCurrentScriptQueryParam('pub_id');
            const action = config.getCurrentScriptQueryParam('action');
            const program = config.getCurrentScriptQueryParam('program');
            const subscriber = config.getCurrentScriptQueryParam('subscriber');
            const baseUrl = config.getCurrentScriptQueryParam('base_url', config.get('default_base_url'));

            if (action !== 'share_form' || !program || !subscriber || !baseUrl || !pubId) {
                return;
            }

            const {hostname} = location;
            const href = window.location.href;
            const currentRef = document.referrer;
            const sessionUuid = Cookies.get("partnero_session_uuid") || uuid();
            const {screen: {width, height}, navigator: {language}} = window;

            const domainParts = location.hostname.split('.');
            const domainPartsCount = domainParts.length;
            const domain = (domainPartsCount > 1 ? domainParts[domainPartsCount - 2] + '.' : '') + domainParts[domainPartsCount - 1];

            Cookies.set('partnero_session_uuid', sessionUuid, {
                expires: 3650,
                domain: domain,
                SameSite: 'None',
                Secure: true
            });

            let data = {
                pub_id: pubId,
                program: program,
                subscriber: subscriber,
                url: href,
                session_uuid: sessionUuid,
                hostname: hostname,
                screen: `${width}x${height}`,
                language: language,
                referrer: currentRef,
                pageType: config.get('share_form_page_type')
            };

            const queryParams = Object.keys(data).map(function (key) {
                return key + '=' + encodeURIComponent(data[key]);
            }).join('&');

            (new Image()).src = `${baseUrl}/pub/v1/analytics/pageview?${queryParams}`;
        }
    }
}
